/**
 * @generated SignedSource<<eb2b56a2caf0d743247e79708ebe7cd0>>
 * @relayHash 18ff4f8d8b4085f53eca6f5430f839ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59

import type { ConcreteRequest } from 'relay-runtime';
export type useCopyContentLinkCopyLinkQuery$variables = {
  contentId: string;
};
export type useCopyContentLinkCopyLinkQuery$data = {
  readonly singleContent: {
    readonly id: string | null;
    readonly links: {
      readonly base: string | null;
      readonly editui: string | null;
      readonly tinyui: string | null;
      readonly webui: string | null;
    } | null;
  } | null;
};
export type useCopyContentLinkCopyLinkQuery = {
  response: useCopyContentLinkCopyLinkQuery$data;
  variables: useCopyContentLinkCopyLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "editui"
          },
          {
            "kind": "ScalarField",
            "name": "webui"
          },
          {
            "kind": "ScalarField",
            "name": "tinyui"
          },
          {
            "kind": "ScalarField",
            "name": "base"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCopyContentLinkCopyLinkQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCopyContentLinkCopyLinkQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "18ff4f8d8b4085f53eca6f5430f839ae",
    "id": "696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59",
    "metadata": {},
    "name": "useCopyContentLinkCopyLinkQuery",
    "operationKind": "query",
    "text": "query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
  }
};
})();

(node as any).hash = "d21c9891b99750e37c7d31e767baec64";

export default node;
